import React from 'react';
import { Typography } from '@mui/material';
import { TextField } from '../../../uikit/inputs/TextField';
import Header from '../../../uikit/parts/Header';
export var MuiTestPage = function () { return (React.createElement(React.Fragment, null,
    React.createElement(Header, null),
    React.createElement(TextField, { placeholder: 'z.B. 750' }),
    React.createElement(TextField, { placeholder: 'z.B. 750', unit: '€/Monat' }),
    React.createElement(Typography, { variant: 'h5' }, "TEST ROBOTO"))); };
